/**
 * KH-GĐ2 7.2.5 — Sổ tiền → "Bị huỷ": hoá đơn bị huỷ trong một ngày (theo GIỜ HUỶ), ai thu, ai huỷ, lý do, số tiền trước
 * và hoá đơn thu lại của cùng lịch (hoá đơn đã thu không sửa được — sửa = huỷ + thu lại). Chỉ người xem được doanh thu.
 */
import { Receipt } from 'lucide-react'
import { useEffect, useState } from 'react'
import { type Api, type HoaDonHuy, tienVnd } from './api.ts'
import { useChiNhanh } from './chi-nhanh-dang-dung.tsx'
import { loiCua, lucViet } from './GoiVi.tsx'
import { canNhanChiNhanh } from './so-tien-chi-nhanh.ts'
import { S } from './text/so-tien.ts'
import { Rong, ThongBao, Xuong } from './ui.tsx'

/** "14:05" giờ VN. */
const gio = (iso: string) => lucViet(iso).slice(11)
/** "05/10 14:05" — ngày thu có thể khác ngày huỷ (`lucViet` trả "05/10/2026 14:05"). */
const ngayGio = (iso: string) => {
  const s = lucViet(iso)
  return `${s.slice(0, 5)} ${s.slice(11)}`
}

export function DsHoaDonHuy({ api, ngay }: { api: Api; ngay: string }) {
  const [ds, setDs] = useState<HoaDonHuy[] | null>(null)
  const [loi, setLoi] = useState<string | null>(null)
  // Tên chi nhánh chỉ ghi khi tiệm nhiều chi nhánh (ADR-101: một nguồn chung).
  const { nhieu } = useChiNhanh()
  useEffect(() => {
    setDs(null)
    setLoi(null)
    let huy = false
    void api
      .hoaDonHuy(ngay)
      .then((r) => {
        if (!huy) setDs(r.hoaDon)
      })
      .catch((e: unknown) => {
        if (!huy) setLoi(loiCua(e))
      })
    return () => {
      huy = true
    }
  }, [api, ngay])

  if (loi !== null) return <ThongBao loai="loi">{loi}</ThongBao>
  if (ds === null) return <Xuong cao={160} />
  if (ds.length === 0) {
    return (
      <div className="the">
        <Rong icon={<Receipt size={26} />} tieuDe={S.huyRong} moTa={S.huyRongPhu} />
      </div>
    )
  }
  return <DanhSachHuy ds={ds} nhieu={nhieu} />
}

/**
 * Danh sách hoá đơn bị huỷ (tách ra để vẽ tĩnh trong test). Tiệm nhiều chi nhánh (hoặc danh sách có ≥ 2 chi nhánh) ghi tên
 * chi nhánh sau số hoá đơn — số hoá đơn đánh theo chi nhánh nên hai tờ có thể trùng số (ADR-044).
 */
export function DanhSachHuy({ ds, nhieu }: { ds: HoaDonHuy[]; nhieu: boolean }) {
  const ghiCn = canNhanChiNhanh(
    ds.map((h) => h.chiNhanh),
    nhieu,
  )
  return (
    <ul className="the ds-huy">
      {ds.map((h) => (
        <li key={h.id}>
          <div className="dau-huy">
            <b>
              {h.so} · {h.khach ?? S.khachLe}
            </b>
            <s>{tienVnd(h.tienTruocVnd)}</s>
          </div>
          {/* Tên chi nhánh là dòng riêng dưới tiêu đề (không làm tiêu đề dài / cắt). Tiệm 1 chi nhánh: không có dòng này. */}
          {ghiCn && h.chiNhanh ? <p className="ten-cn-huy">{h.chiNhanh}</p> : null}
          <p>{S.huyLuc(gio(h.lucHuy), h.nguoiHuy)}</p>
          <p>{S.thuLuc(ngayGio(h.lucThu), h.nguoiThu)}</p>
          {h.lyDo !== null && <p className="ly-do-huy">{S.huyLyDoDong(h.lyDo)}</p>}
          {h.thuLai !== null ? (
            <p>
              {S.thuLai(h.thuLai.so, tienVnd(h.thuLai.tienVnd))}
              {!h.thuLai.conHieuLuc && ` (${S.thuLaiCungHuy})`}
            </p>
          ) : (
            // Lịch bị huỷ hoá đơn mà chưa thu lại = chỗ tiền dễ thất thoát nhất → in đậm màu cảnh báo.
            h.maLich !== null && <p className="chua-thu-lai">{S.chuaThuLai}</p>
          )}
        </li>
      ))}
    </ul>
  )
}
